import { useEffect } from 'react';
import getNodes from './getNodes';
const useActiveIndexSync = ({ id, activeIndex, setActiveIndex, isFocused }) => {
    useEffect(() => {
        if (!isFocused)
            return;
        const nodes = getNodes(id);
        const currentIndex = nodes.indexOf(document.activeElement);
        if (currentIndex !== -1 && currentIndex !== activeIndex) {
            setActiveIndex(currentIndex);
        }
    }, [id, activeIndex, setActiveIndex, isFocused]);
};
export default useActiveIndexSync;
//# sourceMappingURL=useActiveIndexSync.js.map